import { X, User } from 'lucide-react';

interface Instructor {
  id: string;
  name: string;
  description: string;
  image_url: string | null;
}

interface InstructorDetailsModalProps {
  isOpen: boolean;
  instructor: Instructor | null;
  onClose: () => void;
}

export default function InstructorDetailsModal({
  isOpen,
  instructor,
  onClose,
}: InstructorDetailsModalProps) {
  if (!isOpen || !instructor) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/70"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-bold text-gray-900">강사 소개</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            title="닫기"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          {/* Profile Image */}
          <div className="flex justify-center mb-6">
            {instructor.image_url ? (
              <img
                src={instructor.image_url}
                alt={instructor.name}
                className="w-48 h-48 rounded-full object-cover shadow-lg"
              />
            ) : (
              <div className="w-48 h-48 rounded-full bg-gray-100 flex items-center justify-center">
                <User className="w-24 h-24 text-gray-400" />
              </div>
            )}
          </div>

          {/* Name */}
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-4">
            {instructor.name}
          </h3>

          {/* Description */}
          {instructor.description && (
            <div
              className="tiptap prose prose-sm max-w-none text-gray-700"
              dangerouslySetInnerHTML={{ __html: instructor.description }}
            />
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onClose}
            className="w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}
